import React from "react";
import { SEO, MainLayout, TranLayoutMian } from "../../../components";

const TransactionMainPage = () => {
  return (
    <>
      <SEO title="transactions" />
      <MainLayout>
        <TranLayoutMian />
      </MainLayout>
    </>
  );
};

export default TransactionMainPage;
